
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.295 3.363a1.559 1.559 0 001.493 1.098h2.15c.556 0 .758.69.328.994L9.49 6.71a1.543 1.543 0 00-.584 1.721l.734 2.349c.154.491-.427.933-.876.596l-1.824-1.37a1.57 1.57 0 00-1.884.001l-1.814 1.365c-.45.337-1.031-.105-.877-.597l.733-2.343a1.543 1.543 0 00-.586-1.722L.735 5.455a.547.547 0 01.327-.994h2.146c.683 0 1.291-.443 1.492-1.098L5.461.885c.16-.521.913-.521 1.073 0l.761 2.478z","stroke":"#000C1F","stroke-opacity":".8"}})])
          )
        }
      }
    